(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adventure-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    const initialized = new WeakSet();

    const initSlideshow = (root) => {
      if (initialized.has(root)) return;
      initialized.add(root);

      const slides = Array.from(root.querySelectorAll('[data-slide]'));
      if (slides.length <= 1) return;

      const dots = Array.from(root.querySelectorAll('[data-dot]'));
      const prevButton = root.querySelector('[data-prev]');
      const nextButton = root.querySelector('[data-next]');

      let currentIndex = 0;
      let autoplayTimer = null;

      const autoplayEnabled = root.dataset.autoplay === 'true';
      const autoplaySpeed = (parseFloat(root.dataset.autoplaySpeed) || 6) * 1000;

      const goTo = (index) => {
        const nextIndex = (index + slides.length) % slides.length;

        slides.forEach((slide, i) => {
          const isActive = i === nextIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        dots.forEach((dot, i) => {
          const isActive = i === nextIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        currentIndex = nextIndex;
      };

      const next = () => goTo(currentIndex + 1);
      const prev = () => goTo(currentIndex - 1);

      const stopAutoplay = () => {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      };

      const startAutoplay = () => {
        if (!autoplayEnabled) return;
        stopAutoplay();
        autoplayTimer = setInterval(next, autoplaySpeed);
      };

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          next();
          startAutoplay();
        });
      }

      if (prevButton) {
        prevButton.addEventListener('click', () => {
          prev();
          startAutoplay();
        });
      }

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.dataset.dotIndex, 10);
          goTo(index);
          startAutoplay();
        });
      });

      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);

      root.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          prev();
          startAutoplay();
        } else if (event.key === 'ArrowRight') {
          next();
          startAutoplay();
        }
      });

      startAutoplay();
    };

    const initAll = () => {
      document.querySelectorAll('.adventure-hero').forEach(initSlideshow);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector && event.target.querySelector('.adventure-hero');
      if (root) initSlideshow(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-product"] && !Shopify.designMode) return;
  try {
    
  function initFeatureProductGallery(root) {
    var mainImage = root.querySelector('[data-main-image]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    if (!mainImage || !thumbs.length) return;

    thumbs.forEach(function (thumb, index) {
      if (index === 0) thumb.classList.add('is-active');
      thumb.addEventListener('click', function () {
        var url = thumb.getAttribute('data-image');
        var alt = thumb.getAttribute('data-alt');
        if (url) mainImage.setAttribute('src', url);
        if (url) mainImage.setAttribute('srcset', url + ' 1200w');
        if (alt) mainImage.setAttribute('alt', alt);
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  function initFeatureProductAddToCart(root) {
    var cartAddUrl = root.getAttribute('data-cart-add-url') || '/cart/add';
    var button = root.querySelector('[data-add-to-cart]');
    if (!button) return;

    button.addEventListener('click', function () {
      if (button.disabled) return;

      var variantId = button.getAttribute('data-variant-id');
      var label = button.querySelector('[data-btn-label]');
      var originalText = label ? label.textContent : '';

      button.disabled = true;
      if (label) label.textContent = 'Adding...';

      fetch(cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function () {
          if (label) label.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function () {
            if (label) label.textContent = originalText;
            button.disabled = false;
          }, 1600);
        })
        .catch(function () {
          if (label) label.textContent = 'Error — retry';
          setTimeout(function () {
            if (label) label.textContent = originalText;
            button.disabled = false;
          }, 1600);
        });
    });
  }

  (function () {
    var initialized = new WeakSet();

    function setup(section) {
      if (initialized.has(section)) return;
      initialized.add(section);
      initFeatureProductGallery(section);
      initFeatureProductAddToCart(section);
    }

    function setupAll() {
      document.querySelectorAll('.feature-product').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupAll);
    } else {
      setupAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.feature-product');
      if (section) setup(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-gallery-slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    const initGallery = (root) => {
      const mainImageEl = root.querySelector('[data-main-image-el]');
      const thumbs = Array.from(root.querySelectorAll('[data-thumb]'));
      if (!mainImageEl) return;

      // Build the slide list: the main image is slide 0, then each thumbnail
      // in order. This is what the main image rotates through automatically.
      const slides = [{
        full: mainImageEl.getAttribute('src'),
        alt: mainImageEl.getAttribute('alt'),
      }].concat(
        thumbs.map((thumb) => ({
          full: thumb.getAttribute('data-full'),
          alt: thumb.getAttribute('data-alt'),
        }))
      );

      let activeIndex = 0;
      let timer = null;

      const setActive = (index) => {
        const slide = slides[index];
        if (!slide || !slide.full) return;
        activeIndex = index;
        mainImageEl.setAttribute('src', slide.full);
        mainImageEl.removeAttribute('srcset');
        mainImageEl.removeAttribute('sizes');
        if (slide.alt) mainImageEl.setAttribute('alt', slide.alt);
        thumbs.forEach((thumb, i) => {
          thumb.classList.toggle('is-active', i === activeIndex - 1);
        });
      };

      const goToNext = () => {
        const nextIndex = (activeIndex + 1) % slides.length;
        setActive(nextIndex);
      };

      const stopAutoplay = () => {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      };

      const startAutoplay = () => {
        if (timer || slides.length < 2) return;
        if (root.getAttribute('data-autoplay') !== 'true') return;
        const interval = parseInt(root.getAttribute('data-autoplay-interval'), 10) || 2000;
        timer = window.setInterval(goToNext, interval);
      };

      const restartAutoplay = () => {
        stopAutoplay();
        startAutoplay();
      };

      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => {
          setActive(i + 1);
          restartAutoplay();
        });
      });

      // Pause the rotation while a shopper is looking closely / interacting,
      // resume once they move on.
      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      root.addEventListener('focusin', stopAutoplay);
      root.addEventListener('focusout', startAutoplay);

      startAutoplay();
    };

    const initAll = () => {
      document.querySelectorAll('.featured-product-gallery').forEach(initGallery);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('.featured-product-gallery');
      if (root) initGallery(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    const initGallery = (root) => {
      const mainImageEl = root.querySelector('[data-main-image-el]');
      const thumbs = Array.from(root.querySelectorAll('[data-thumb]'));
      if (!mainImageEl || !thumbs.length) return;

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const full = thumb.getAttribute('data-full');
          const alt = thumb.getAttribute('data-alt');
          if (full) mainImageEl.setAttribute('src', full);
          if (alt) mainImageEl.setAttribute('alt', alt);
          thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
        });
      });
    };

    const initAll = () => {
      document.querySelectorAll('.featured-product-gallery').forEach(initGallery);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector && event.target.querySelector('.featured-product-gallery');
      if (root) initGallery(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["location-search-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    const initialized = new WeakSet();

    const debounce = (fn, delay) => {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = window.setTimeout(() => fn(...args), delay);
      };
    };

    const initBanner = (root) => {
      if (initialized.has(root)) return;
      initialized.add(root);

      const form = root.querySelector('[data-location-search-form]');
      const input = root.querySelector('[data-location-search-input]');
      const resultsEl = root.querySelector('[data-location-search-results]');
      const searchUrl = root.dataset.searchUrl || '/search';
      const examples = (root.dataset.searchExamples || 'Search')
        .split(',')
        .map((word) => word.trim())
        .filter(Boolean);

      if (!form || !input) return;

      // Rotating placeholder text, e.g. "Search" -> "Michigan" -> "Dallas" -> "Cincinnati" -> loop.
      // Pauses while the visitor is typing or the field is focused.
      let placeholderIndex = 0;
      let rotationTimer = null;

      const showNextPlaceholder = () => {
        if (!examples.length) return;
        input.setAttribute('placeholder', examples[placeholderIndex]);
        placeholderIndex = (placeholderIndex + 1) % examples.length;
      };

      const startRotation = () => {
        if (rotationTimer || examples.length < 2) return;
        showNextPlaceholder();
        rotationTimer = window.setInterval(showNextPlaceholder, 1800);
      };

      const stopRotation = () => {
        if (rotationTimer) {
          window.clearInterval(rotationTimer);
          rotationTimer = null;
        }
      };

      if (examples.length) {
        input.setAttribute('placeholder', examples[0]);
        placeholderIndex = 1 % examples.length;
      }

      startRotation();

      input.addEventListener('focus', stopRotation);
      input.addEventListener('blur', () => {
        if (!input.value) startRotation();
      });

      // Live product search -> lets a visitor jump straight to a matching
      // product page instead of landing on a generic results list.
      let latestProducts = [];
      let activeIndex = -1;
      let abortController = null;

      const closeResults = () => {
        resultsEl.hidden = true;
        resultsEl.innerHTML = '';
        activeIndex = -1;
      };

      const renderResults = (products) => {
        latestProducts = products;
        activeIndex = -1;

        if (!products.length) {
          resultsEl.innerHTML = '<div class="location-search-banner__result-empty">No matching products</div>';
          resultsEl.hidden = false;
          return;
        }

        resultsEl.innerHTML = products
          .map((product, index) => {
            const image = product.image
              ? `<img class="location-search-banner__result-image" src="${product.image}" alt="" loading="lazy">`
              : '<span class="location-search-banner__result-image"></span>';
            return `
              <a href="${product.url}" class="location-search-banner__result" data-result-index="${index}">
                ${image}
                <span>${product.title}</span>
              </a>
            `;
          })
          .join('');

        resultsEl.hidden = false;
      };

      const fetchProducts = async (term) => {
        if (abortController) abortController.abort();
        abortController = new AbortController();

        try {
          const response = await fetch(
            `/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide`,
            { signal: abortController.signal, credentials: 'same-origin' }
          );

          if (!response.ok) {
            closeResults();
            return;
          }

          const data = await response.json();
          const products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderResults(products);
        } catch (error) {
          if (error.name !== 'AbortError') {
            closeResults();
          }
        }
      };

      const debouncedFetch = debounce((term) => fetchProducts(term), 220);

      input.addEventListener('input', () => {
        const term = input.value.trim();

        if (term.length < 2) {
          closeResults();
          return;
        }

        debouncedFetch(term);
      });

      const highlightResult = (index) => {
        const items = resultsEl.querySelectorAll('[data-result-index]');
        items.forEach((item) => item.classList.remove('location-search-banner__result--active'));

        if (index >= 0 && items[index]) {
          items[index].classList.add('location-search-banner__result--active');
          items[index].scrollIntoView({ block: 'nearest' });
        }
      };

      input.addEventListener('keydown', (event) => {
        if (resultsEl.hidden || !latestProducts.length) return;

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          activeIndex = Math.min(activeIndex + 1, latestProducts.length - 1);
          highlightResult(activeIndex);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          activeIndex = Math.max(activeIndex - 1, 0);
          highlightResult(activeIndex);
        } else if (event.key === 'Escape') {
          closeResults();
        }
      });

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const term = input.value.trim();

        if (!term) return;

        const chosen =
          activeIndex >= 0 && latestProducts[activeIndex]
            ? latestProducts[activeIndex]
            : latestProducts[0];

        if (chosen && chosen.url) {
          window.location.href = chosen.url;
          return;
        }

        // No product match yet -- fall back to the site's normal search results.
        window.location.href = `${searchUrl}?q=${encodeURIComponent(term)}`;
      });

      document.addEventListener('click', (event) => {
        if (!root.contains(event.target)) {
          closeResults();
        }
      });
    };

    const initAll = () => {
      document.querySelectorAll('.location-search-banner').forEach(initBanner);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const banner = event.target.querySelector && event.target.querySelector('.location-search-banner');
      if (banner) initBanner(banner);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  function initProductCarousel(root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;

    var prevBtn = root.querySelector('[data-carousel-prev]');
    var nextBtn = root.querySelector('[data-carousel-next]');

    function step() {
      var card = track.querySelector('.product-carousel__card');
      var gap = 16;
      var cardWidth = card ? card.getBoundingClientRect().width : 220;
      return cardWidth + gap;
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateArrows);
    });

    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  function initAddToCart(root) {
    var cartAddUrl = root.getAttribute('data-cart-add-url') || '/cart/add';
    var buttons = root.querySelectorAll('[data-add-to-cart]');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;

        var variantId = button.getAttribute('data-variant-id');
        var label = button.querySelector('[data-btn-label]');
        var originalText = label ? label.textContent : '';

        button.disabled = true;
        if (label) label.textContent = 'Adding...';

        fetch(cartAddUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
          })
          .then(function () {
            if (label) label.textContent = 'Added ✓';
            document.dispatchEvent(new CustomEvent('cart:updated'));
            setTimeout(function () {
              if (label) label.textContent = originalText;
              button.disabled = false;
            }, 1600);
          })
          .catch(function () {
            if (label) label.textContent = 'Error — retry';
            setTimeout(function () {
              if (label) label.textContent = originalText;
              button.disabled = false;
            }, 1600);
          });
      });
    });
  }

  (function () {
    var initialized = new WeakSet();

    function setup(section) {
      if (initialized.has(section)) return;
      initialized.add(section);
      initProductCarousel(section);
      initAddToCart(section);
    }

    function setupAll() {
      document.querySelectorAll('.product-carousel').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupAll);
    } else {
      setupAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.product-carousel');
      if (section) setup(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-logo-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    const setupMarquee = (section) => {
      if (section.dataset.marqueeInit === 'true') return;
      section.dataset.marqueeInit = 'true';

      const track = section.querySelector('.scrolling-logo-section__track');
      const viewport = section.querySelector('.scrolling-logo-section__viewport');
      const baseGroup = section.querySelector('[data-marquee-base]');
      if (!track || !viewport || !baseGroup) return;

      // The marquee loops by shifting the track exactly one base-group's
      // width to the left, then snapping back. That only looks seamless if
      // there's always at least one more full group's worth of content
      // trailing behind wherever the track currently sits — otherwise, once
      // the viewport is wider than a single group, the track runs out of
      // logos before the loop point and you see empty space. This adds as
      // many extra clones as needed to guarantee that, and tells the CSS
      // animation exactly how far (in px) one base group actually is.
      const rebuild = () => {
        Array.from(track.querySelectorAll('[data-marquee-clone]')).forEach((el) => el.remove());

        const groupWidth = baseGroup.getBoundingClientRect().width;
        if (!groupWidth) return;

        const viewportWidth = viewport.getBoundingClientRect().width;
        const needed = Math.max(2, Math.ceil((viewportWidth * 2) / groupWidth));
        const currentGroups = track.querySelectorAll('.scrolling-logo-section__group').length;

        for (let i = currentGroups; i < needed; i += 1) {
          const clone = baseGroup.cloneNode(true);
          clone.removeAttribute('data-marquee-base');
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('data-marquee-clone', 'true');
          clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
          track.appendChild(clone);
        }

        track.style.setProperty('--scrolling-logo-single-width', `${groupWidth}px`);
      };

      rebuild();

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(rebuild, 200);
      });

      const images = Array.from(track.querySelectorAll('img'));
      let pending = images.filter((img) => !img.complete).length;
      if (pending === 0) {
        requestAnimationFrame(rebuild);
      } else {
        images.forEach((img) => {
          img.addEventListener(
            'load',
            () => {
              pending -= 1;
              if (pending <= 0) rebuild();
            },
            { once: true }
          );
        });
      }
    };

    const initAll = () => {
      document.querySelectorAll('.scrolling-logo-section').forEach(setupMarquee);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector && event.target.querySelector('.scrolling-logo-section');
      if (root) setupMarquee(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-bar"] && !Shopify.designMode) return;
  try {
    
  function initSearchBar(root) {
    var widget = root.querySelector('[data-search-widget]');
    if (!widget) return;

    var form = widget.querySelector('[data-search-form]');
    var input = widget.querySelector('[data-search-input]');
    var resultsBox = widget.querySelector('[data-search-results]');
    var predictiveUrl = widget.getAttribute('data-predictive-url');
    var searchUrl = widget.getAttribute('data-search-url');
    var maxResults = widget.getAttribute('data-max-results') || '6';
    var moneyFormat = widget.getAttribute('data-money-format') || '$' + '{' + '{amount}}';

    var debounceTimer = null;
    var currentController = null;
    var activeIndex = -1;
    var currentLinks = [];
      var teamIndexEl = widget.querySelector('[data-team-index]');
      var teamIndex = [];
      if (teamIndexEl) {
      try {
      teamIndex = JSON.parse(teamIndexEl.textContent || '[]');
      } catch (e) {
      teamIndex = [];
      }
      }

    function formatMoney(amount) {
      var num = parseFloat(amount);
      if (isNaN(num)) return '';
      var fixed = num.toFixed(2);
      var parts = fixed.split('.');
      var formatted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
      var match = moneyFormat.match(/\{\{\s*amount[^}]*\s*\}\}/);
      if (match) {
        return moneyFormat.replace(match[0], formatted);
      }
      return formatted;
    }

    function escapeHtml(value) {
      var div = document.createElement('div');
      div.textContent = value || '';
      return div.innerHTML;
    }

    function closeResults() {
      resultsBox.hidden = true;
      resultsBox.innerHTML = '';
      currentLinks = [];
      activeIndex = -1;
    }

    function setActive(index) {
      currentLinks.forEach(function (link) {
        link.classList.remove('is-active');
      });
      if (index >= 0 && index < currentLinks.length) {
        currentLinks[index].classList.add('is-active');
        currentLinks[index].scrollIntoView({ block: 'nearest' });
      }
      activeIndex = index;
    }

    function renderGroup(title, items, kind) {
      if (!items || !items.length) return '';
      var html = '<div class="search-bar__results-group">';
      html += '<div class="search-bar__results-group-title">' + escapeHtml(title) + '</div>';
      items.forEach(function (item) {
        var image = item.image || (item.featured_image ? item.featured_image.url : '');
        var price = '';
        if (kind === 'product') {
          var priceValue = item.price || item.price_min;
          if (priceValue) {
            var priceText = formatMoney(priceValue);
            if (item.price_min && item.price_max && item.price_min !== item.price_max) {
              priceText = 'From ' + priceText;
            }
            price = '<div class="search-bar__result-price">' + priceText + '</div>';
          }
        }
        html += '<a href="' + item.url + '" class="search-bar__result" data-search-result>';
        html += '<span class="search-bar__result-image">';
        if (image) {
          html += '<img src="' + image + '" alt="" loading="lazy" width="44" height="44">';
        }
        html += '</span>';
        html += '<span class="search-bar__result-info">';
        html += '<span class="search-bar__result-title">' + escapeHtml(item.title) + '</span>';
        html += price;
        html += '</span>';
        html += '</a>';
      });
      html += '</div>';
      return html;
    }

    function renderResults(data, query) {
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      var collections = (data.resources && data.resources.results && data.resources.results.collections) || [];

      if (!products.length && !collections.length) {
        resultsBox.innerHTML = '<div class="search-bar__empty">No results found for &ldquo;' + escapeHtml(query) + '&rdquo;</div>';
        resultsBox.hidden = false;
        currentLinks = [];
        activeIndex = -1;
        return;
      }

      var html = '';
      html += renderGroup('Collections', collections, 'collection');
      html += renderGroup('Products', products, 'product');
      html += '<a class="search-bar__view-all" href="' + searchUrl + '?q=' + encodeURIComponent(query) + '&type=product,collection">View all results for &ldquo;' + escapeHtml(query) + '&rdquo;</a>';

      resultsBox.innerHTML = html;
      resultsBox.hidden = false;
      currentLinks = Array.prototype.slice.call(resultsBox.querySelectorAll('[data-search-result]'));
      activeIndex = -1;
    }

      function getTeamMatches(query) {
      var q = (window.wellServedSearchQuery ? window.wellServedSearchQuery(query) : query).toLowerCase();
      var seen = {};
      var matches = [];
      teamIndex.forEach(function (item) {
      if (item.team && item.team.toLowerCase().indexOf(q) !== -1 && !seen[item.url]) {
      seen[item.url] = true;
      matches.push({ title: item.team + " — " + item.title, url: item.url, image: item.image, price: item.price });
      }
      });
      return matches;
      }

    function fetchResults(query) {
      if (currentController) {
        currentController.abort();
      }
      currentController = new AbortController();

      var url = predictiveUrl + '.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product,collection' +
        '&resources[limit]=' + maxResults +
        '&resources[options][unavailable_products]=last';

      fetch(url, { signal: currentController.signal, headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Search request failed');
          return response.json();
        })
        .then(function (data) {
        var teamMatches = getTeamMatches(query);
        if (teamMatches.length) {
          data.resources = data.resources || {};
          data.resources.results = data.resources.results || {};
          data.resources.results.products = teamMatches;
          data.resources.results.collections = [];
        }
          renderResults(data, query);
        })
        .catch(function (error) {
          if (error.name !== 'AbortError') {
            closeResults();
          }
        });
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      if (debounceTimer) clearTimeout(debounceTimer);

      if (query.length < 2) {
        closeResults();
        return;
      }

      debounceTimer = setTimeout(function () {
        fetchResults(query);
      }, 250);
    });

    input.addEventListener('keydown', function (event) {
      if (resultsBox.hidden || !currentLinks.length) return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        setActive(Math.min(activeIndex + 1, currentLinks.length - 1));
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        setActive(Math.max(activeIndex - 1, 0));
      } else if (event.key === 'Enter') {
        if (activeIndex >= 0 && currentLinks[activeIndex]) {
          event.preventDefault();
          window.location.href = currentLinks[activeIndex].href;
        }
      } else if (event.key === 'Escape') {
        closeResults();
      }
    });

    document.addEventListener('click', function (event) {
      if (!widget.contains(event.target)) {
        closeResults();
      }
    });

    form.addEventListener('submit', function (event) {
      var query = input.value.trim();
      if (!query) {
        event.preventDefault();
      }
    });
  }

  function initCardsCarousel(root) {
    var wrap = root.querySelector('[data-cards-track]');
    if (!wrap) return;

    var track = wrap;
    var prevBtn = root.querySelector('[data-cards-prev]');
    var nextBtn = root.querySelector('[data-cards-next]');
    if (!prevBtn || !nextBtn) return;

    function step() {
      var card = track.querySelector('.search-bar__card');
      var gap = 16;
      var cardWidth = card ? card.getBoundingClientRect().width : 200;
      return cardWidth + gap;
    }

    function updateArrows() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateArrows);
    });

    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  (function () {
    var initialized = new WeakSet();

    function setup(section) {
      if (initialized.has(section)) return;
      initialized.add(section);
      initSearchBar(section);
      initCardsCarousel(section);
    }

    function setupAll() {
      document.querySelectorAll('.search-bar').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupAll);
    } else {
      setupAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.search-bar');
      if (section) setup(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["see-it-in-action"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    const initialized = new WeakSet();

    const initSeeItInAction = (root) => {
      if (initialized.has(root)) return;
      initialized.add(root);

      const modal = root.querySelector('[data-video-modal]');
      if (!modal) return;

      const openTriggers = Array.from(root.querySelectorAll('[data-open-video]'));
      const closeTriggers = Array.from(modal.querySelectorAll('[data-close-video]'));
      const video = modal.querySelector('video');
      const iframe = modal.querySelector('[data-video-iframe]');
      const shouldAutoplay = modal.getAttribute('data-autoplay') === 'true';

      const openModal = () => {
        modal.hidden = false;
        if (iframe) {
          const embedSrc = iframe.getAttribute('data-embed-src');
          if (embedSrc) {
            const separator = embedSrc.indexOf('?') === -1 ? '?' : '&';
            const src = shouldAutoplay ? embedSrc + separator + 'autoplay=1' : embedSrc;
            iframe.setAttribute('src', src);
          }
        }
        if (video) {
          video.currentTime = 0;
          if (shouldAutoplay) {
            video.play().catch(() => {});
          }
        }
        document.body.style.overflow = 'hidden';
      };

      const closeModal = () => {
        modal.hidden = true;
        if (iframe) {
          iframe.setAttribute('src', '');
        }
        if (video) {
          video.pause();
        }
        document.body.style.overflow = '';
      };

      openTriggers.forEach((trigger) => {
        trigger.addEventListener('click', openModal);
      });

      closeTriggers.forEach((trigger) => {
        trigger.addEventListener('click', closeModal);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !modal.hidden) {
          closeModal();
        }
      });
    };

    const initAll = () => {
      document.querySelectorAll('.see-it-in-action').forEach(initSeeItInAction);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector && event.target.querySelector('.see-it-in-action');
      if (root) initSeeItInAction(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-social-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    const initialized = new WeakSet();
    let tiktokScriptEl = null;

    const ensureInstagramScript = () => {
      if (window.instgrm) {
        window.instgrm.Embeds.process();
        return;
      }
      if (document.querySelector('script[data-ssv-instagram]')) return;
      const script = document.createElement('script');
      script.async = true;
      script.src = '//www.instagram.com/embed.js';
      script.setAttribute('data-ssv-instagram', 'true');
      script.addEventListener('load', () => {
        if (window.instgrm) window.instgrm.Embeds.process();
      });
      document.body.appendChild(script);
    };

    const ensureTiktokScript = () => {
      if (tiktokScriptEl) {
        tiktokScriptEl.remove();
      }
      tiktokScriptEl = document.createElement('script');
      tiktokScriptEl.async = true;
      tiktokScriptEl.src = 'https://www.tiktok.com/embed.js';
      tiktokScriptEl.setAttribute('data-ssv-tiktok', 'true');
      document.body.appendChild(tiktokScriptEl);
    };

    const initEmbeds = (root) => {
      if (root.dataset.hasInstagram === 'true') ensureInstagramScript();
      if (root.dataset.hasTiktok === 'true') ensureTiktokScript();
    };

    const initShopPanels = (root) => {
      const cards = Array.from(root.querySelectorAll('.shoppable-social-video__card'));

      const closeAll = (except) => {
        cards.forEach((card) => {
          if (card === except) return;
          const panel = card.querySelector('[data-shop-panel]');
          const btn = card.querySelector('[data-shop-toggle]');
          if (panel && !panel.hidden) {
            panel.hidden = true;
            if (btn) btn.setAttribute('aria-expanded', 'false');
          }
        });
      };

      cards.forEach((card) => {
        const btn = card.querySelector('[data-shop-toggle]');
        const panel = card.querySelector('[data-shop-panel]');
        if (!btn || !panel) return;

        btn.addEventListener('click', (event) => {
          event.stopPropagation();
          const isHidden = panel.hidden;
          closeAll(card);
          panel.hidden = !isHidden ? true : false;
          btn.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
        });
      });

      document.addEventListener('click', () => closeAll(null));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeAll(null);
      });
    };

    const initScroll = (root) => {
      const row = root.querySelector('[data-scroll-row]');
      const prevBtn = root.querySelector('[data-scroll-prev]');
      const nextBtn = root.querySelector('[data-scroll-next]');
      if (!row) return;

      const scrollByCard = (direction) => {
        const card = row.querySelector('.shoppable-social-video__card');
        const amount = card ? card.getBoundingClientRect().width + 16 : 260;
        row.scrollBy({ left: amount * direction, behavior: 'smooth' });
      };

      if (prevBtn) prevBtn.addEventListener('click', () => scrollByCard(-1));
      if (nextBtn) nextBtn.addEventListener('click', () => scrollByCard(1));
    };

    const initTabs = (root) => {
      const tabsBar = root.querySelector('[data-tabs]');
      const row = root.querySelector('[data-scroll-row]');
      if (!tabsBar || !row) return;

      const tabs = Array.from(tabsBar.querySelectorAll('[data-tab-filter]'));
      const cards = Array.from(row.querySelectorAll('.shoppable-social-video__card'));

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const filter = tab.getAttribute('data-tab-filter');

          tabs.forEach((t) => {
            const isActive = t === tab;
            t.classList.toggle('is-active', isActive);
            t.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          cards.forEach((card) => {
            const category = card.getAttribute('data-category') || '';
            const matches = filter === 'all' || category === filter;
            card.hidden = !matches;
          });

          row.scrollTo({ left: 0, behavior: 'smooth' });
        });
      });
    };

    const initActiveVideo = (root) => {
      if (root.dataset.enlargeActive !== 'true') return;

      const setActiveFromFocus = () => {
        const active = document.activeElement;
        const cards = Array.from(root.querySelectorAll('.shoppable-social-video__card'));
        if (active && active.tagName === 'IFRAME') {
          const card = active.closest('.shoppable-social-video__card');
          if (card && root.contains(card)) {
            cards.forEach((c) => c.classList.toggle('is-playing', c === card));
            return;
          }
        }
      };

      // When a user clicks into an Instagram/TikTok embed's iframe to play it,
      // the browser moves focus into that (cross-origin) iframe. We can't see
      // click events inside it, but the top window reliably fires "blur" the
      // moment focus leaves it — checking document.activeElement right after
      // tells us which iframe (and therefore which card) just became active.
      window.addEventListener('blur', () => {
        setTimeout(setActiveFromFocus, 0);
      });
    };

    const initShoppableSocialVideo = (root) => {
      if (initialized.has(root)) return;
      initialized.add(root);

      initEmbeds(root);
      initShopPanels(root);
      initScroll(root);
      initTabs(root);
      initActiveVideo(root);
    };

    const initAll = () => {
      document.querySelectorAll('.shoppable-social-video').forEach(initShoppableSocialVideo);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector && event.target.querySelector('.shoppable-social-video');
      if (root) initShoppableSocialVideo(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-shop-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    const initialized = new WeakSet();

    const cartAddUrl = () => {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return `${root.replace(/\/$/, '')}/cart/add.js`;
    };

    const cartUrl = () => {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return `${root.replace(/\/$/, '')}/cart.js`;
    };

    const handleAddToCartClick = async (button) => {
      if (button.disabled) return;

      const variantId = button.dataset.variantId;
      if (!variantId) return;

      const label = button.querySelector('[data-button-label]');
      const defaultText = button.dataset.defaultText || (label ? label.textContent.trim() : '');
      const addedText = button.dataset.addedText || 'Added!';
      const addingText = button.dataset.addingText || 'Adding…';

      const pageContainer = document.getElementById('PageContainer');
      const cartType = pageContainer ? pageContainer.dataset.cartType : null;

      const payload = { items: [{ id: variantId, quantity: 1 }] };
      if (cartType === 'drawer') payload.sections = 'cart-drawer';

      button.disabled = true;
      if (label) label.textContent = addingText;

      try {
        const response = await fetch(cartAddUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          if (label) label.textContent = errorData.message || 'Unavailable';
          setTimeout(() => {
            if (label) label.textContent = defaultText;
            button.disabled = false;
          }, 2000);
          return;
        }

        const data = await response.json();

        if (window.eventBus) {
          if (cartType === 'drawer' && data.sections) {
            window.eventBus.emit('update:cart:drawer', data);
            window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
          }
          window.eventBus.emit('cart:added', { sectionId: null });
        }

        if (label) label.textContent = addedText;

        fetch(cartUrl())
          .then((res) => res.json())
          .then((cart) => {
            if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') {
              window.wetheme.updateCartCount(cart);
            }
          })
          .catch(() => {});

        setTimeout(() => {
          if (label) label.textContent = defaultText;
          button.disabled = false;
        }, 1500);
      } catch (error) {
        if (label) label.textContent = defaultText;
        button.disabled = false;
      }
    };

    const initAddToCartButtons = (root) => {
      root.querySelectorAll('[data-team-add-to-cart]').forEach((button) => {
        if (button.dataset.teamAtcBound) return;
        button.dataset.teamAtcBound = 'true';
        button.addEventListener('click', () => handleAddToCartClick(button));
      });
    };

    const initTabs = (root) => {
      if (initialized.has(root)) return;
      initialized.add(root);

      const buttons = Array.from(root.querySelectorAll('[data-tab-button]'));
      const panels = Array.from(root.querySelectorAll('[data-tab-panel]'));

      const activate = (key) => {
        buttons.forEach((button) => {
          const isMatch = button.dataset.tabKey === key;
          button.classList.toggle('is-active', isMatch);
          button.setAttribute('aria-selected', isMatch ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const isMatch = panel.dataset.tabKey === key;
          panel.classList.toggle('is-active', isMatch);
          panel.hidden = !isMatch;
        });
      };

      buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          // Only intercept when there's a real panel to switch to -- otherwise
          // let the link fall back to the collection page it points to.
          const key = button.dataset.tabKey;
          const hasPanel = panels.some((panel) => panel.dataset.tabKey === key);

          if (hasPanel) {
            event.preventDefault();
            activate(key);
          }
        });
      });

      root.querySelectorAll('[data-show-more]').forEach((showMoreButton) => {
        showMoreButton.addEventListener('click', () => {
          const panel = showMoreButton.closest('[data-tab-panel]');
          if (!panel) return;

          panel.querySelectorAll('.team-shop-tabs__card--extra').forEach((card) => {
            card.style.display = 'flex';
          });

          showMoreButton.hidden = true;
        });
      });

      initAddToCartButtons(root);
    };

    const initAll = () => {
      document.querySelectorAll('.team-shop-tabs').forEach(initTabs);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector && event.target.querySelector('.team-shop-tabs');
      if (root) initTabs(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-duo-spotlight"] && !Shopify.designMode) return;
  try {
    
  function initVideoDuo(root) {
    var triggers = Array.from(root.querySelectorAll('[data-open-video]'));
    var modal = root.querySelector('[data-video-modal]');
    if (!triggers.length || !modal) return;

    var panels = Array.from(modal.querySelectorAll('[data-video-panel]'));
    var closers = Array.from(modal.querySelectorAll('[data-close-video]'));
    var autoplay = modal.getAttribute('data-autoplay') === 'true';

    function stopPanel(panel) {
      var video = panel.querySelector('video');
      var iframe = panel.querySelector('[data-video-iframe]');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
      if (iframe) {
        var src = iframe.getAttribute('data-embed-src');
        if (src) {
          iframe.setAttribute('src', '');
        }
      }
    }

    function openVideo(index) {
      panels.forEach(function (panel) {
        var isMatch = panel.getAttribute('data-panel-index') === String(index);
        panel.hidden = !isMatch;
        if (isMatch) {
          var iframe = panel.querySelector('[data-video-iframe]');
          if (iframe) {
            var src = iframe.getAttribute('data-embed-src');
            if (src) {
              var autoplayParam = autoplay ? '&autoplay=1' : '';
              iframe.setAttribute('src', src + autoplayParam);
            }
          }
          var video = panel.querySelector('video');
          if (video && autoplay) {
            video.play().catch(function () {});
          }
        } else {
          stopPanel(panel);
        }
      });
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeVideo() {
      modal.hidden = true;
      document.body.style.overflow = '';
      panels.forEach(stopPanel);
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var index = trigger.getAttribute('data-video-index');
        if (index) openVideo(index);
      });
    });

    closers.forEach(function (closer) {
      closer.addEventListener('click', closeVideo);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeVideo();
    });
  }

  (function () {
    var initialized = new WeakSet();

    function setup(section) {
      if (initialized.has(section)) return;
      initialized.add(section);
      initVideoDuo(section);
    }

    function setupAll() {
      document.querySelectorAll('.video-duo').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupAll);
    } else {
      setupAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.video-duo');
      if (section) setup(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
